module.exports = __webpack_public_path__ + "img/success.a2132876.png";